import React from 'react';
import * as S from './SignInTags.styles';


const SignInTags = (props) => {
  const {tagText, imgsrc,onClick} = props;
  return(
    <S.SignInTag onClick={(evt)=>{
      onClick(evt);
 }}>
       {imgsrc? <img src={imgsrc} width='19px' height='19px'/> :null}
        <S.TagText>{tagText}</S.TagText>
    </S.SignInTag>
);
    }
export default SignInTags;
